'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagVnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-1.52588e-05 0C9.33332 1.24254e-05 18.6667 1.19209e-06 28 1.19209e-06C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 -2.36928e-06 20L-1.52588e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-1.52588e-05 0L28 1.19209e-06V20H-2.36928e-06L-1.52588e-05 0Z",
          fill: "#EA403F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 12.34L10.4733 14.8541L11.7745 10.7231L8.29366 8.1459L12.6246 8.1069L14 4L15.3754 8.1069L19.7063 8.1459L16.2255 10.7231L17.5267 14.8541L14 12.34Z",
          fill: "#FFFE4E"
        }
      )
    ]
  }
);
const VpFlagVnAsset = forwardRef(FlagVnAsset);

export { VpFlagVnAsset as default };
